import * as amplitude from '@amplitude/analytics-browser';
import { getEnv } from 'common-nextjs';

export function initializeAmplitudeSdk() {
  const apiKey = getEnv('AMPLITUDE_API_KEY');
  if (!apiKey) {
    if (getEnv() !== 'production') {
      console.warn('[Amplitude] No API key found');
    }
    return;
  }

  try {
    amplitude.init(apiKey, {
      logLevel: amplitude.Types.LogLevel.Warn,
      autocapture: {
        attribution: true,
        pageViews: true,
        sessions: true,
        formInteractions: false,
        fileDownloads: false,
        elementInteractions: false,
      },
    });

    if (getEnv() !== 'production') {
      console.log('[Amplitude] Initialized with Browser SDK 2');
    }
  } catch (error) {
    if (getEnv() !== 'production') {
      console.error('[Amplitude] Initialization error:', error);
    }
  }
}
